import "./styles.less";

import { PageHeader, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";

import { ArrowLeftOutlined } from "@ant-design/icons";
import { BreadCrumbs } from "../../../Components/SEO/BreadCrumbs/web";
import { useRouter } from "next/router";
import { useTheme } from "../../../Styles/ThemeHook";

const { Text } = Typography;

export const Navigation = ({ type = "default" }: { type: "default" | "small" | "none" }) => {
	const { theme } = useTheme();

	const router = useRouter();

	const [backButton, setbackButton] = useState(false);

	useEffect(() => setbackButton(typeof history !== "undefined" && history.length > 1), []);

	return (
		<PageHeader
			className="pd-navigation"
			backIcon={
				backButton && (
					<Space size={theme.spacing.smSpacing}>
						<ArrowLeftOutlined />
						{type == "none" ? null : type !== "small" ? (
							<Text>{"Volver a la búsqueda"}</Text>
						) : (
							<Text>{"Volver"}</Text>
						)}
					</Space>
				)
			}
			onBack={() => router.back()}
			title={type !== "default" && " "}
			subTitle={type == "default" && <BreadCrumbs />}
		/>
	);
};
